import { useTeam } from '@foxtrotplatform/platform-micro-site-core';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface RequireUserOrgProps {
  children: JSX.Element;
}

export const RequireUserTeam: React.FunctionComponent<
  RequireUserOrgProps & React.HTMLAttributes<HTMLDivElement>
> = ({ children }: RequireUserOrgProps): JSX.Element | null => {
  const navigate = useNavigate();
  const { currentTeam } = useTeam();
  const [teamExists, setTeamExists] = useState<boolean>(false);

  React.useEffect(() => {
    if (!currentTeam) {
      navigate('/team');
    } else {
      setTeamExists(true);
    }
  }, [currentTeam]);

  return teamExists ? children : null;
};
